// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__6QHHy","tab":"styles_tab__gVQNU","active":"styles_active__6dg_L","reversed":"styles_reversed__tWNli"};